import { Notification } from "constant/notifications";
import { useEffect, useState } from "react";
import { AiOutlineCheck, AiOutlinePlus } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  ArtistPayload,
  CheckingFollowingStatus,
  followArtist,
} from "services/favorite/favoriteService";
import UserProfileService from "services/UserProfileService";
import { triggerSuccessNotification } from "utils/notification";

type FollowButtonProps = {
  user?: { id?: number };
  setUpdatedUser: (user: any) => void;
  follow: boolean;
  setFollow: (value: boolean) => void;
  setShowLoginModal?: (value: boolean) => void;
};

function FollowButton({
  user,
  setUpdatedUser,
  follow,
  setFollow,
  setShowLoginModal,
}: FollowButtonProps) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [followDetails, setFollowDetails] = useState<Array<number | string>>(
    [],
  );

  const targetUserId = user?.id;

  const checkFollowingStatus = async () => {
    if (!loggedInUser) return;

    try {
      if (targetUserId) {
        const resp = await CheckingFollowingStatus(targetUserId, "user");
        if (resp?.status === true) {
          setFollow(resp?.data?.data);
        }
      }
    } catch (err) {
      console.log("err :::", err);
    }
  };

  useEffect(() => {
    if (loggedInUser) {
      checkFollowingStatus();
    }
  }, [targetUserId]);

  const handleFollow = () => {
    if (!targetUserId) return;

    if (loggedInUser) {
      const followObject: ArtistPayload = {
        id: targetUserId,
        user_type: "user",
        is_follow: true,
      };

      if (!follow) {
        followArtist(followObject).then((res) => {
          if (res?.status === 200) {
            triggerSuccessNotification(Notification.Followed);
          }
        });
        setFollow(true);
      } else {
        followArtist({
          id: targetUserId,
          user_type: "user",
          is_follow: false,
        }).then((res) => {
          if (res?.status === 200) {
            triggerSuccessNotification(Notification.Unfollowed);
          }
        });
        setFollow(false);
      }
    } else {
      setShowLoginModal?.(true);
      return;
    }
  };

  useEffect(() => {
    if (!targetUserId) return;

    const timer = setTimeout(async () => {
      await UserProfileService.getUserById(targetUserId).then((res: any) => {
        setUpdatedUser(res?.profile);
      });
    }, 1000);

    return () => clearTimeout(timer);
  }, [follow, targetUserId, setUpdatedUser]);

  useEffect(() => {
    if (loggedInUser) {
      UserProfileService.getFollowingById(loggedInUser?.id).then((res) => {
        const followingIds = res?.profile?.following?.data.map(
          (item: any) => item.id,
        );
        setFollowDetails(followingIds ?? []);
      });
    }
  }, [loggedInUser?.id]);

  useEffect(() => {
    if (!targetUserId) {
      setFollow(false);
      return;
    }

    if (followDetails.includes(targetUserId)) {
      setFollow(true);
    } else {
      setFollow(false);
    }
  }, [followDetails, targetUserId, setFollow]);

  return (
    <button
      onClick={handleFollow}
      className={`flex h-[40px] w-[130px] shrink-0 items-center justify-center gap-2 rounded-full text-[14px] font-semibold transition-all duration-200 active:scale-95 ${
        follow
          ? "border border-white/20 bg-white/5 text-white hover:border-[#F50537]/50 hover:bg-[#F50537]/10 hover:text-[#F50537]"
          : "bg-[#F50537] text-white shadow-[0_6px_18px_rgba(245,5,55,0.35)] hover:bg-[#d90430]"
      }`}
    >
      {follow ? (
        <>
          <AiOutlineCheck className="shrink-0" size={17} /> Following
        </>
      ) : (
        <>
          <AiOutlinePlus className="shrink-0" size={17} /> Follow
        </>
      )}
    </button>
  );
}

export default FollowButton;
